import { createContext, ReactNode, useContext, useState } from 'react';

interface UIVisibilityContextType {
  isLiveChatVisible: boolean;
  setLiveChatVisible: (visible: boolean) => void;
  hideFooterOnMobile: boolean;
  setHideFooterOnMobile: (hidden: boolean) => void;
  hideNativeTabBar: boolean;
  setHideNativeTabBar: (hidden: boolean) => void;
}

const UIVisibilityContext = createContext<UIVisibilityContextType | null>(null);

export function UIVisibilityProvider({ children }: { children: ReactNode }) {
  const [isLiveChatVisible, setLiveChatVisible] = useState(true);
  const [hideFooterOnMobile, setHideFooterOnMobile] = useState(false);
  const [hideNativeTabBar, setHideNativeTabBar] = useState(false);

  return (
    <UIVisibilityContext.Provider
      value={{
        isLiveChatVisible,
        setLiveChatVisible,
        hideFooterOnMobile,
        setHideFooterOnMobile,
        hideNativeTabBar,
        setHideNativeTabBar,
      }}
    >
      {children}
    </UIVisibilityContext.Provider>
  );
}

export function useUIVisibility() {
  const context = useContext(UIVisibilityContext);
  if (!context) {
    throw new Error('useUIVisibility must be used within UIVisibilityProvider');
  }
  return context;
}
